export default function () {
	const sliderContainer = document.querySelector('.slider-projects');

	if (!sliderContainer) {
    return;
  }

  const slides = sliderContainer.querySelectorAll('.slider-slide');
  const sliderWrapper = sliderContainer.querySelector('.slider-wrapper');
  const prevBtn = sliderContainer.querySelector('.slider-button-prev');
  const nextBtn = sliderContainer.querySelector('.slider-button-next');
  const btnDisabledClass = "slider-button-disabled";
  const pagination = sliderContainer.querySelector('.slider-pagination');
  const paginationCurrent = pagination.querySelector('.pagination-current');
  const paginationTotal = pagination.querySelector('.pagination-total');

  let currentSlide = 1;

  const padNumber = (number) => {
    return number < 10 ? "0" + number : number;
  }

  const getTotalSlides = () => {
    return sliderWrapper.offsetWidth > ((slides[0].offsetWidth * 2)) ? slides.length - 1 : slides.length;
  }

  const updateNavigation = () => {
    paginationCurrent.innerText = padNumber(currentSlide);
    paginationTotal.innerText = padNumber(getTotalSlides());

    if (currentSlide === 1) {
      prevBtn.classList.add(btnDisabledClass);
      prevBtn.setAttribute('aria-disabled', true);
    } else {
      prevBtn.classList.remove(btnDisabledClass);
      prevBtn.removeAttribute('aria-disabled');
    }

    if (currentSlide === getTotalSlides()) {
      nextBtn.classList.add(btnDisabledClass);
      nextBtn.setAttribute('aria-disabled', true);
    } else {
      nextBtn.classList.remove(btnDisabledClass);
      nextBtn.removeAttribute('aria-disabled');
    }
  }

  const updateSlides = () => {
    sliderWrapper.style = "transform: translateX(" + -(slides[currentSlide - 1].offsetLeft) + "px)";
  }

  prevBtn.addEventListener('click', () => {
    if (currentSlide > 1) {
      currentSlide--;
    }
    updateNavigation();
    updateSlides();
  });

  nextBtn.addEventListener('click', () => {
    if (currentSlide < getTotalSlides()) {
      currentSlide++;
    }
    updateNavigation();
    updateSlides();
  });

  updateNavigation();

  window.addEventListener('resize', () => {
    if (currentSlide > getTotalSlides()) {
      currentSlide = getTotalSlides();
    }

    updateNavigation();
    updateSlides();
  });
}
